var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Spacer',{attrs:{"y":"s"}},[_c('Wrapper',{attrs:{"size":"xs","margin":false}},[_c('div',[_c('Grid',{attrs:{"col":"12","row-gap":"m"}},[_c('Spacer',{staticClass:"typo--m",attrs:{"x":"s"}},[_vm._v(" "+_vm._s(_vm.$labels.create_accunt)+" ")]),_c('Form',{staticClass:"form--single",attrs:{"id":"register"}})],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }